/**
 * External link handling functionality
 * @module links
 */

import { isValidURL } from '../utils';

/**
 * Processes external links
 */
export function processExternalLinks() {
  const currentDomain = window.location.hostname;

  document.querySelectorAll('.wp-site-blocks a').forEach(link => {
    const href = link.getAttribute('href');
    if (isValidURL(href) && isExternalDomain(href, currentDomain)) {
      markAsExternal(link);
    }
  });
}

function isExternalDomain(href, currentDomain) {
  return new URL(href).hostname !== currentDomain;
}

function markAsExternal(link) {
  link.setAttribute('target', '_blank');
  link.classList.add('is-external');
}
